define('SageDotCom/Components/Content/SolutionFinder',[
    "jquery",
    'SageDotCom/DataLayer/tealium',
    "SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderDropdownOpen",
    "SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderOptionSelected",
    "SageDotCom/DataLayer/Events/SolutionFinder/solutionFinderGo"
],
    function ($, tealium, dropdownOpenEvent, optionSelectedEvent, navigateEvent) {
        function SolutionFinder(scope) {
            const solutionFinder = $(scope);
            const selects = solutionFinder.find(".solution-finder-select");
            const industrySelector = solutionFinder.find(".solution-finder-select.industry-select");
            const sizeSelector = solutionFinder.find(".solution-finder-select.company-size-select");
            const exploreButton = solutionFinder.find(".explore-button");
            const errorMessages = solutionFinder.find(".error-message");

            var currentIndustry = "";
            var currentSize = "";
            var industrySelectIsOpen = false;
            var sizeSelectIsOpen = false;

            industrySelector.on("change", function () {
                //clear error message
                showError("none");
                var selectedValue = industrySelector.val();
                var selectText = industrySelector.find("option:selected").text();

                if (isValidInternalUrl(selectedValue)) {
                    // only allow button link to be changed if it is a valid url
                    exploreButton.attr("href", selectedValue);
                }

                currentIndustry = selectText;

                if (selectIsValid(industrySelector)) {
                    var optionSelectedEventData = optionSelectedEvent.GenerateEventMetadata(selectText);
                    tealium.event(optionSelectedEventData);
                }
            });

            sizeSelector.on("change", function () {
                //clear error message
                showError("none");

                var selectedValue = sizeSelector.val();
                var selectText = "company size";

                if (selectedValue === "small") {
                    selectText = "under_20_employees";
                }
                else if (selectedValue === "medium") {
                    selectText = "over_20_employees";
                }

                currentSize = selectText;

                if (selectIsValid(sizeSelector)) {
                    var optionSelectedEventData = optionSelectedEvent.GenerateEventMetadata(selectText);
                    tealium.event(optionSelectedEventData);
                }
            });

            // ensure button goes to correct link if preselected option has been populated
            if (industrySelector.val() !== exploreButton.attr("href")) {
                industrySelector.trigger("change");
            }
            if (sizeSelector.val() !== "#") {
                sizeSelector.trigger("change");
            }

            // set up the required events to detect the select expanding
            setUpDropdownOpenTracking(industrySelector);
            setUpDropdownOpenTracking(sizeSelector);

            // check select options are populated and navigate
            exploreButton.on("click", function (e) {
                if (!selectIsValid(industrySelector) && !selectIsValid(sizeSelector)) {
                    e.preventDefault();
                    showError("both");
                }
                else if (!selectIsValid(industrySelector)) {
                    e.preventDefault();
                    showError("industry");
                }
                else if (!selectIsValid(sizeSelector)) {
                    e.preventDefault();
                    showError("size");
                }
                else {
                    // fire go event
                    //e.preventDefault(); // remove this once development is finished
                    var goEventData = navigateEvent.GenerateEventMetadata(currentIndustry, currentSize);
                    tealium.event(goEventData);
                }
            });


            // helper functions
            function setUpDropdownOpenTracking(select) {
                var dropDownType = "";

                if (select.hasClass("industry-select")) {
                    dropDownType = "industry"
                }
                else if (select.hasClass("company-size-select")) {
                    dropDownType = "company_size"
                }

                if (dropDownType === "") {
                    return;
                }


                $(select).on("keydown", function (e) {
                    if (e.key === 'Enter' || e.keyCode === 13 || e.key === ' ' || e.keyCode === 32) {
                        if (dropDownType === "industry") {
                            industrySelectIsOpen = true;
                        }
                        else if (dropDownType === "company_size") {
                            sizeSelectIsOpen = true;
                        }
                        select.addClass("expanded");
                    }
                });

                $(select).on("blur", function (e) {
                    if (dropDownType === "industry") {
                        industrySelectIsOpen = false;
                    }
                    else if (dropDownType === "company_size") {
                        sizeSelectIsOpen = false;
                    }
                    select.removeClass("expanded");
                });

                $(select).on("mousedown", function (e) {
                    if (dropDownType === "industry") {
                        industrySelectIsOpen = !industrySelectIsOpen;
                        industrySelectIsOpen ? select.addClass("expanded") : select.removeClass("expanded");
                    }
                    else if (dropDownType === "company_size") {
                        sizeSelectIsOpen = !sizeSelectIsOpen;
                        sizeSelectIsOpen ? select.addClass("expanded") : select.removeClass("expanded");
                    }
                });

                $(select).on("click", function (e) {
                    const rect = select[0].getBoundingClientRect();
                    var xposition = e.clientX;
                    var yposition = e.clientY;

                    const isInComponent =
                        xposition >= rect.left &&
                        xposition <= rect.right &&
                        yposition >= rect.top &&
                        yposition <= rect.bottom;

                    if (!isInComponent) {
                        if (dropDownType === "industry") {
                            industrySelectIsOpen = false;
                        }
                        else if (dropDownType === "company_size") {
                            sizeSelectIsOpen = false;
                        }
                        select.removeClass("expanded");
                    }
                });

                var selectObserver = new MutationObserver(function (mutations) {
                    for (const mutation of mutations) {
                        // only want to fire the event if the expanded class has been added
                        // i.e. (don't want to track other classes or the removal of expanded class)
                        if (mutation.oldValue === null || mutation.oldValue === undefined || mutation.oldValue === "") {
                            return;
                        }

                        var expandedClassAdded = !(mutation.oldValue.includes("expanded")) && mutation.target.classList.contains("expanded");

                        if (expandedClassAdded) {
                            var dropdownOpenedEventData = dropdownOpenEvent.GenerateEventMetadata(dropDownType);
                            tealium.event(dropdownOpenedEventData);
                        }
                    }
                });

                var selectDOM = select[0];
                selectObserver.observe(selectDOM, {
                    attributes: true,
                    attributeFilter: ['class'],
                    attributeOldValue: true
                });
            }

            function selectIsValid(select) {
                if (select === null || select === undefined || select.val() === "" || select.val() === "#" || select.length === 0 || select.val() === null) {
                    return false;
                }

                return true;
            }

            function showError(errorType) {
                var errorClass = "";
                var selectClass = "";
                switch (errorType) {
                    case "both":
                        errorClass = $(window).width() >= 768 ? "missing-both-desktop" : "missing-both-mobile";
                        selectClass = "solution-finder-select";
                        break;
                    case "industry":
                        errorClass = "missing-industry";
                        selectClass = "industry-select";
                        break;
                    case "size":
                        errorClass = "missing-size";
                        selectClass = "company-size-select";
                        break;
                    default:
                        errorClass = "no class";
                        selectClass = "no class";
                }

                errorMessages.each(function () {
                    var error = $(this);
                    $(error).hasClass(errorClass) ? error.show() : error.hide();
                });

                selects.each(function () {
                    var select = $(this);
                    $(select).hasClass(selectClass) ? select.addClass("invalid") : select.removeClass("invalid");
                });
            }

            function isValidInternalUrl(url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin);
                    return parsedUrl.origin === window.location.origin;
                } catch (e) {
                    return false;
                }
            }
        }

        SolutionFinder.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new SolutionFinder(args.scope);
        };

        return SolutionFinder;
    });
